import { Store } from "vuex";
import { RootState } from "..";
import { namespace } from "../modules/ai/aiSearch";
import { AiAnswer, AiCacheSearchResultItem, AiFeedbackRequest } from "@/types/ai/aiSearch";

export default class AiSearch {
    private store: Store<RootState>;

    constructor(store: Store<RootState>) {
        this.store = store;
    }

    public get searchResultsLoaded(): boolean {
        return this.store.getters[`${namespace}/searchResults`] !== null;
    }

    public get searchResults(): AiCacheSearchResultItem[] {
        return this.store.getters[`${namespace}/searchResults`];
    }

    public async loadSearchResultsAsync(
        question: String,
        searchScope: "in_portal" | "outside_portal" | "collection",
        portalId: Number,
        collectionId: Number
    ): Promise<{ status: number; results: AiCacheSearchResultItem[] }> {
        return this.store.dispatch(`${namespace}/loadAiSearchResultsAsync`, {
            question: question,
            searchScope: searchScope,
            portalId: portalId,
            collectionId: collectionId,
            showMore: false,
            disableCache: false
        });
    }

    public loadMoreAsync(
        searchScope: "in_portal" | "outside_portal" | "collection"
    ): Promise<{ status: number; results: AiCacheSearchResultItem[] }> {
        return this.store.dispatch(`${namespace}/loadMore`, {
            searchScope: searchScope
        });
    }

    public async loadAiAnswerAsync(
        question: String,
        content_item_id: String,
        searchScope: "in_portal" | "outside_portal" | "collection"
    ): Promise<AiAnswer | undefined> {
        return this.store.dispatch(`${namespace}/loadAiAnswerAsync`, {
            searchScope: searchScope,
            question: question,
            content_item_id: content_item_id
        });
    }

    public getFeedbackScope(searchScope: "in_portal" | "outside_portal" | "collection", contentItemId: string | null): any {
        return this.store.getters[`${namespace}/getFeedbackScope`](searchScope, contentItemId);
    }

    public postAiFeedback(feedback: AiFeedbackRequest): Promise<any> {
        return this.store.dispatch(`${namespace}/postAiFeedback`, feedback);
    }

    public setCollectionFilter(collectionId: number): void {
        this.store.commit(`${namespace}/setCollectionFilter`, collectionId);
    }

    public setItemsToShow(scope: "in_portal" | "outside_portal" | "collection", itemsToShow: number): void {
        this.store.commit(`${namespace}/setItemsToShow`, {
            scope: scope,
            itemsToShow: itemsToShow
        });
    }

    public getCollectionFilter(): number {
        return this.store.getters[`${namespace}/getCollectionFilter`];
    }

    public getCollectionIds(scope: "all" | "collection"): number[] {
        return this.store.getters[`${namespace}/getCollectionIds`](scope);
    }

    public getItemsToShow(
        scope: "in_portal" | "outside_portal" | "collection",
        searchText: string,
        portalId: number | null,
        collectionId: number | null
    ): number {
        return this.store.getters[`${namespace}/getItemsToShow`](scope, searchText, portalId, collectionId);
    }

    public areAllItemsLoaded(scope: "in_portal" | "outside_portal" | "collection"): boolean {
        return this.store.getters[`${namespace}/areAllItemsLoaded`](scope);
    }

    public getPageSize() {
        return this.store.getters[`${namespace}/getPageSize`];
    }

    public clearCache(searchScope: string) {
        return this.store.commit(`${namespace}/clearCache`, searchScope);
    }
}
